import { useEffect, useRef } from 'react';

/**
 * Custom hook to automatically focus an input element when the component is open
 */
function useAutoFocusInput(isOpen: boolean) {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (isOpen) {
      inputRef.current?.focus();
    }
  }, [isOpen]);

  return inputRef;
}

export default useAutoFocusInput;
